import { Lock } from 'lucide-react';

interface FeatureDisabledBannerProps {
  feature: 'community' | 'ai' | 'admin';
  className?: string;
}

const MESSAGES: Record<FeatureDisabledBannerProps['feature'], { title: string; body: string }> = {
  community: {
    title: 'Community features are not available in desktop mode',
    body: 'Showroom, trading, offers, and community profiles require the SiliconVault web app. Visit siliconvault.app to connect with other collectors.',
  },
  ai: {
    title: 'AI image analysis is not configured',
    body: 'Open Settings → AI Configuration and enter your API credentials to enable hardware identification.',
  },
  admin: {
    title: 'Admin panel is not available in desktop mode',
    body: 'User management and platform administration require the SiliconVault web app.',
  },
};

export function FeatureDisabledBanner({ feature, className = '' }: FeatureDisabledBannerProps) {
  const { title, body } = MESSAGES[feature];

  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed p-12 text-center ${className}`}
      style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}
    >
      <Lock className="h-10 w-10 opacity-40" />
      <div>
        <p className="font-semibold" style={{ color: 'var(--text)' }}>
          {title}
        </p>
        <p className="mt-1 text-sm">{body}</p>
      </div>
    </div>
  );
}
